<template>
	<router-view>
	</router-view>
</template>

<script>
	export default {
		name: "ProjectViewTemplate"
	};
</script>

<style scoped>

</style>